<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-if="!modoAtendimento" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="edData" />
            </div>

            <div class="form-item-char05">
                <label class="label-caption">Hora</label>
                <input type="text" class="input-center" v-time-mask v-model="edHora" />
            </div>

            <div class="form-item">
                <GabinetePessoaFrame v-model:objSelecionado="pessoaSelecionada"/>
            </div>

            <div class="form-item">
                <label class="label-caption">Assunto</label>
                <input type="text" v-model="edAssunto" maxlength="100" v-uppercase />
            </div>
        </div>
        
        <div class="row-end">
            <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            <button class="btn-confirm" @click="salvarDados">Iniciar</button>
        </div>
    </div>


    <div v-if="!modoAtendimento && lsDados.length>0" class="table-wrapper" >
        <table>
            <thead>
                <tr>
                    <th>Data</th>
                    <th>Hora</th>
                    <th>Pessoa</th>
                    <th>Assunto</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  
                    @click="setAtendimento(obj)">
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtagenda) }}</td>
                    <td class="col-width-char05 center">{{ Funcoes.formatTimeFromJson(obj.hragenda) }}</td>
                    <td>{{ obj.nmpessoa }}</td>
                    <td class="col-width-char40">{{ obj.assunto }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-if="modoAtendimento"><GabineteAgendaAtendimentoPage :idEdicao="idAtendimento" @close="cancelForm" /></div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarGabineteAgenda } from '@/models/GabineteAgenda';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validacoes } from '@/funcoes/validacoes';
import GabineteAgendaAtendimentoPage from './GabineteAgendaAtendimentoPage.vue';
import GabinetePessoaFrame from '@/components/frames/GabinetePessoaFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close', 'salvo']);

const msgAlerta = ref(false);
const isLoading = ref(false);

const edAssunto = ref(null);
const edData = ref(Funcoes.dataAtual());
const edHora = ref(Funcoes.strHoraAtual());
const idAtendimento = ref(null);
const modoAtendimento = ref(false);
const pessoaSelecionada = ref(null);
const lsDados = ref([]);


function cancelForm() {emit('close');}


async function lerDados() {
    // LISTAR OS AGENDAMENTOS "EM ATENDIMENTO"
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/gabinete_agenda', {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 4});
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function salvarDados() {
    try {
        msgAlerta.value=null;
        Validacoes.validarId(pessoaSelecionada.value, 'Informe a pessoa');
        Validacoes.validarTexto(edAssunto.value, 'Informe o assunto');
        isLoading.value=true;
        const payload = criarGabineteAgenda();
        payload.id = 0;
        payload.idmunicipio = globalStore.idmunicipio;
        payload.idgabinete_pessoa = pessoaSelecionada.value.id;
        payload.assunto = edAssunto.value;
        payload.dtagenda = Funcoes.strDataAtual();
        payload.hragenda = Funcoes.strHoraAtual();
        payload.lgconfirmacao = globalStore.idlogin;
        payload.lgchegada = globalStore.idlogin;
        payload.atendimento_dhinicio = Funcoes.strDataHoraAtual;
        payload.idlogin = globalStore.idlogin;

        const response = await Api.genericPut('/cad/gabinete_agenda', payload);
        if (response.bolok===1){
            idAtendimento.value = response.id;
            modoAtendimento.value = true;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}            
}

function setAtendimento(obj){
    idAtendimento.value = obj.id;
    modoAtendimento.value = true;
}

onMounted(lerDados)
</script>